module.exports = __webpack_public_path__ + "img/arrows-from-dotted-line.d35b6bcf.svg";